import { render, staticRenderFns } from "./ModeratorInformationActionCell.vue?vue&type=template&id=ccf9fd84&scoped=true&"
import script from "./ModeratorInformationActionCell.vue?vue&type=script&lang=babel&"
export * from "./ModeratorInformationActionCell.vue?vue&type=script&lang=babel&"
import style0 from "./ModeratorInformationActionCell.vue?vue&type=style&index=0&id=ccf9fd84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf9fd84",
  null
  
)

export default component.exports